(function () {
  'use strict';

  angular
    .module('app.rankingScoreReportInformation')
    .factory('rankingScoreReportInformationService', ['$q', '$http', '$rootScope', 'measureService',
      function ($q, $http, $rootScope, measureService) {
        var service = {};

        function checkResponse(data) {
          return data;
        }

        function getMessage(data) {
          if (data) {
            return data.message;
          }
          return false;
        }

        function handleRequest(url) {
          var deferred = $q.defer(), result = 'requestFail';
          $http.get(url)
            .success(function (data) {
              var dataRes = angular.fromJson(data);

              if (checkResponse(dataRes)) {
                deferred.resolve(dataRes);
              } else {
                deferred.reject(getMessage(dataRes) || result);
              }
            })
            .error(function () {
              deferred.reject(result);
            });

          return deferred.promise;
        }

        function getInfluencerInformation(params) {
          var url_getInfluencerInformation = $rootScope.apiUrl + 'measure/getRankingScoreInfluencerInformation?' + $.param(params);
          return handleRequest(url_getInfluencerInformation);
        }

        service.getInfluencerInformation = getInfluencerInformation;  

        return service;
      }]);
})();